import findAllFor from '../filters/find-all-for';

const getTextResizeConstraintForElement = (element) => {
  const constraints = findAllFor(element);

  return constraints.find((constraint) => constraint.textResizable);
};

export default getTextResizeConstraintForElement;
